module.exports = __webpack_public_path__ + "static/media/IDEX_france2030_couleur.f5bd5e11.jpg";